// @flow
import {
	RadioSelect,
	Slider,
	NumberInput,
	SimpleCollapse,
	UniversalPaginationButton,
	ListToggle,
	Typeahead,
	PasswordToggle,
	SocialShare,
	AnchorsList,
	RadioSelectTab,
	RedirectToUrl,
  Form,
} from 'fg-frontend';


import Webslider from './components/Webslider';
import SelectDesign from './components/SelectDesign';
import Tooltip from './components/Tooltip';
import GtmHandler from './components/GtmHandler';
import TriggerInViewport from './components/TriggerInViewport';
import GreedyMenu from './components/GreedyMenu';
import LazyImage from './components/LazyImage';

import configureEshopComponents from './configureEshopComponents';

export default (props) => {
	switch (props.decorator || props.is) {
		case 'RadioSelect':
		case 'CheckboxSelect':
			return RadioSelect;
		case 'SimpleCollapse':
			return SimpleCollapse;
		case 'GreedyMenu':
			return GreedyMenu;
		case 'Typeahead':
			return Typeahead;
		case 'SelectDesign':
			return SelectDesign;
		case 'ListToggle':
			return ListToggle;
		case 'PasswordToggle':
			return PasswordToggle;
		case 'SocialShare':
			return SocialShare;
		case 'Webslider':
			return Webslider;
		case 'AnchorsList':
			return AnchorsList;
		case 'Slider':
			return Slider;
		case 'RadioSelectTab':
			return RadioSelectTab;
		case 'NumberInput':
			return NumberInput;
		case 'UniversalPaginationButton':
			return UniversalPaginationButton;
		case 'Tooltip':
			return Tooltip;
		case 'GtmHandler':
			return GtmHandler;
		case 'TriggerInViewport':
			return TriggerInViewport;
		case 'LazyImage':
			return LazyImage;
		case 'RedirectToUrl':
			return RedirectToUrl;
    case 'Form':
      return Form;
		default:
			const eshopComponent = configureEshopComponents(props);
			if (eshopComponent) {
				return eshopComponent;
			}
			else {
				console.log(`Unknown component ${props.decorator || props.is}`);
				return null;
			}
	}
};



// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/configureWebComponents.js